import {cloneDeep as _cloneDeep} from 'lodash';
import RoomPurposesModel from "./../../models/RoomPurposesModel"
const RoomPurposesModule = {
    namespaced: true,
    state: () => ({
        roomPurposes: [],
        roomPurpose: _cloneDeep(RoomPurposesModel, true),
    }),
    getters: {
        getRoomPurposes (state) {
            return state.roomPurposes
        },
        getRoomPurpose (state) {
            return state.roomPurpose
        },
    },
    mutations: {
        setRoomPurposes (state, payload) {
            state.roomPurposes = payload
        },
        setRoomPurpose (state, payload) {
            state.roomPurpose = payload
        },
    },
    actions: {
        setRoomPurposes (context, payload) {
            context.commit('setRoomPurposes', payload);
        },
        setRoomPurpose (context, payload) {
            context.commit('setRoomPurpose', payload);
        },
    },

}

export default RoomPurposesModule;
